/* eslint-disable camelcase */
// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Tooltip from 'rc-tooltip';

// assets
import CssBookStatus from './BookStatus.scss';

export class BookStatusComponent extends Component {
  static propTypes = {
    book: PropTypes.shape({
      alacarte: PropTypes.bool,
      coming_soon: PropTypes.bool,
      indexable: PropTypes.bool,
      licensed: PropTypes.bool,
    }),
    statusType: PropTypes.oneOf(['small', 'medium']),
  };

  static defaultProps = {
    book: {
      alacarte: false,
      indexable: false,
      licensed: false,
    },
    statusType: 'small',
  };

  render() {
    const { indexable, licensed, alacarte, coming_soon } = this.props.book;
    const { statusType } = this.props;

    let src;

    if (indexable && licensed && !alacarte) {
      src = `images/ckbk-book.png`;
    } else if (coming_soon) {
      src = `images/ckbk-soon-book.png`;
    }

    let width = 33;
    let height = 13;
    if (statusType === 'medium') {
      width = 70;
      height = 27.5;
    }

    let statusText = '';
    if (indexable) {
      statusText = 'Available on ckbk now';
    } else {
      statusText = 'Coming to ckbk soon';
    }

    return src ? (
      <Tooltip
        overlay={<div className="book-status__tooltip">{statusText}</div>}
        mouseEnterDelay={0.75}
        placement="top"
      >
        <img src={src} width={width} height={height} alt={statusText} />
      </Tooltip>
    ) : (
      <div style={{ height, width, display: 'inline-block' }} />
    );
  }
}

export default withStyles(CssBookStatus)(BookStatusComponent);
